import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

export const useUpdatePaymentAmount = () => {
  const queryClient = useQueryClient();

  const handleNetworkError = useHandleNetworkError(
    "Error updating payment amount"
  );

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async ({ payment, amountDue }) => {
      const axiosInstance = await createAxiosInstance();
      const updatedPayment = {
        ...payment,
        amountDue: amountDue,
      };
      const response = await axiosInstance.post(
        `${tenantVal}/consultationpaymentdue`,
        updatedPayment
      );
      return response.data;
    },
    onSuccess: () => {
      toast.success("Payment amount updated successfully");

      queryClient.invalidateQueries({ queryKey: ["consultationPaymentsDue"] });
      queryClient.invalidateQueries({ queryKey: ["activeConsultation"] });
    },
    onError: handleNetworkError,
  });
};
